import { LoadingSpinner } from "components/loadingSpinner";
import { useLogin } from "hooks";
import { FC, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { showErrorModal } from "redux/slices";
import { useAppDispatch } from "redux/store";
import { Guid } from "types";
import { PasswordCheck } from "./password-check";

export const LoginByGuid: FC<Guid> = ({ guid }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const goToNoGuidPage = () => navigate("/");

  const { login, apiStatus } = useLogin(goToNoGuidPage);

  const validateGuid = useCallback(
    (guid: string) => {
      let isValid = false;
      if (guid.length === 0) {
        dispatch(
          showErrorModal({
            text: "Controlla l'url che hai digitato: manca il nome dell'account per accedere al tuo box.",
          })
        );
      } else if (guid.length !== 8) {
        dispatch(
          showErrorModal({
            text: "Controlla l'url che hai digitato: il nome dell'account per accedere al tuo box non è corretto.",
          })
        );
      } else {
        isValid = true;
      }
      return isValid;
    },
    [dispatch]
  );

  useEffect(() => {
    const isValid = validateGuid(guid);
    if (isValid) {
      login(guid);
    } else {
      goToNoGuidPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, validateGuid]);

  if (apiStatus === "fulfilled") {
    return <PasswordCheck guid={guid} />;
  }
  if (apiStatus === "pending") {
    return <LoadingSpinner />;
  }
  return null;
};
